/* oxlint-disable typescript/ban-ts-comment */
import equal from "fast-deep-equal/es6";
import { useEffect, useState } from "react";
import { usePrevious } from "react-use";

// oxlint-disable-next-line typescript/no-explicit-any
export function useDeepMemo<F extends (...args: any[]) => unknown>(
  func: F,
  ...values: Parameters<F>
): ReturnType<F> {
  // @ts-expect-error
  const [s, setS] = useState<ReturnType<F>>(func(...values));
  const previousValues = usePrevious(values) || values;

  useEffect(() => {
    if (previousValues.some((v, i) => values[i] !== v) && !equal(previousValues, values)) {
      // @ts-expect-error
      setS(func(...values));
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [func, ...values, ...previousValues]);

  return s;
}
